import {useTheme, useWindowSize} from '@primer/react-brand/esm'
import {clsx} from 'clsx'

import type {ThemedVisual} from '../../../../Index.types'
import {Product} from '../../Product/Product'
import type {ProductUIProps} from '../../ProductUI/ProductUI'

import Styles from './FeatureGridVisual.module.css'

export interface FeatureGridVisualProps {
  visual: ThemedVisual
  productUI: Omit<ProductUIProps, 'children'>
  variant: 'platform' | 'feature' | 'compactFeature'
}

export const defaultProps: Partial<FeatureGridVisualProps> = {}

const RING_COLORS: Record<ProductUIProps['shadowColor'], string> = {
  green: 'var(--color-green)',
  blueLight: 'var(--color-blueLight)',
  blueDark: 'var(--color-indigo)',
  orange: 'var(--color-orange)',
  pink: 'var(--color-pink)',
}

export const FeatureGridVisual = (props: FeatureGridVisualProps) => {
  const initializedProps: FeatureGridVisualProps = {...defaultProps, ...props}
  const {visual, productUI, variant} = initializedProps
  const {colorMode} = useTheme()
  const {isSmall: isTablet, isLarge: isDesktop} = useWindowSize()
  const imageUrl = colorMode === 'dark' ? visual.url.dark || visual.url.light : visual.url.light

  return (
    <div className={clsx(Styles.FeatureGridVisual, Styles[`FeatureGridVisual--${variant}`])}>
      <Product
        theme={colorMode}
        hasRoundedCorners={Boolean(isTablet)}
        hasRingShine
        mediaPosition={isDesktop ? 'center-right' : isTablet ? 'center-right' : 'center-left'}
        productUI={productUI}
        ringColor={RING_COLORS[productUI.shadowColor]}
      >
        <div className={Styles.FeatureGridVisual__content}>
          {imageUrl && (
            <img className={Styles.FeatureGridVisual__image} src={imageUrl} alt={visual.alt} loading="lazy" />
          )}
        </div>
      </Product>
    </div>
  )
}
